// web/src/components/browser/FileTile.tsx
import { cn } from "../../lib/utils";
import { useNavigation } from "../../stores/navigation";
import { useLongPress } from "../../hooks/useLongPress";

function ext(name: string): string {
  const i = name.lastIndexOf(".");
  return i >= 0 ? name.slice(i + 1).toUpperCase() : "FILE";
}

interface Props {
  name: string;
  sizeLabel: string;
  modifiedLabel: string;
  onTap: () => void;
}

export function FileTile({ name, sizeLabel, modifiedLabel, onTap }: Props) {
  const selected = useNavigation((s) => s.selection.has(name));
  const active = useNavigation((s) => s.selectionActive);
  const toggle = useNavigation((s) => s.toggleSelection);
  const activate = useNavigation((s) => s.activateSelection);
  const { didLongPress, ...handlers } = useLongPress(() => activate(name));

  return (
    <button
      {...handlers}
      onClick={(e) => {
        if (didLongPress()) return;
        if (active) {
          toggle(name);
          return;
        }
        if (e.shiftKey || e.metaKey || e.ctrlKey) {
          toggle(name);
          return;
        }
        onTap();
      }}
      className={cn(
        "relative flex aspect-square flex-col justify-between rounded-md border border-border bg-white/5 p-2 text-left text-[10px] text-text-soft",
        selected && "outline outline-2 outline-accent",
      )}
    >
      <span className="font-mono text-[10px] font-bold tracking-wide text-accent-soft">
        {ext(name)}
      </span>
      <div>
        <div className="line-clamp-2 text-[10.5px] leading-snug text-text">
          {name}
        </div>
        <div className="mt-0.5 font-mono text-[9px] text-text-dim">
          {sizeLabel} · {modifiedLabel}
        </div>
      </div>
    </button>
  );
}
